import {createSelector} from 'reselect';
import {getTripData} from './store';
import {getListingIds, getSuperlativeBadges} from './listing';
import {getListingOverviewBadges} from './listingOverviewBadges';
import {getNldBadge} from './badges';

const getCheckoutSelectedData = createSelector(
    [getListingIds, getTripData],
    (listing, tripData) => ({
        adult_count: tripData.adults.toString(),
        child_count: tripData.children.toString(),
        date_end: tripData.departDateText,
        date_start: tripData.arriveDateText,
        listing_id: listing.listingId,
        with_pets: `${tripData.hasPets}`
    })
);

const getPropertySummaryPresented = createSelector(
    [getListingIds, getTripData, getListingOverviewBadges, getNldBadge, getSuperlativeBadges],
    (listing, tripData, rankedBadges, nldBadge, superlativeBadge) => ({
        adultCount: tripData.adults,
        childCount: tripData.children,
        dateEnd: tripData.departDateText,
        dateStart: tripData.arriveDateText,
        listingId: listing.listingId,
        hasPets: tripData.hasPets,
        rankedBadges,
        nldBadge,
        superlativeBadge
    })
);

export {getPropertySummaryPresented, getCheckoutSelectedData};
